const LEAVES = Array.from({ length: 36 }, (_, i) => {
  const r = Math.sqrt((i + 0.5) / 36), th = i * 2.39996;
  return [120 + Math.cos(th) * r * 92, 74 + Math.sin(th) * r * 44, 17 + (i % 3) * 4];
});

/** The Great Baobab: one leaf cluster grows per Seed of Life collected (persistent across sessions). */
export const GreatBaobab = ({ seeds = 0, fresh = 0, size = 120, testId = "great-baobab" }) => {
  const shown = Math.min(LEAVES.length, 3 + seeds * 2), from = Math.max(3, shown - fresh * 2);
  return (
    <svg viewBox="0 0 240 230" width={size} height={(size * 230) / 240} role="img" aria-label={`Grand Baobab : ${shown} bouquets de feuilles`} data-testid={testId} data-leaves={shown}>
      <ellipse cx="120" cy="218" rx="70" ry="8" fill="#0A2540" opacity=".18" />
      <path d="M96 218 C100 170 92 140 84 112 L156 112 C148 140 140 170 144 218 Z" fill="#7A5A3F" />
      <path d="M108 216 C110 176 106 146 100 118 M132 216 C130 178 134 148 140 118" stroke="#5E4430" strokeWidth="4" fill="none" />
      <path d="M90 116 C70 96 50 92 30 92 M106 112 C100 86 104 66 108 52 M134 112 C140 86 136 66 132 50 M150 116 C170 96 190 92 210 90" stroke="#7A5A3F" strokeWidth="10" strokeLinecap="round" fill="none" />
      {LEAVES.map(([x, y, r], i) => (
        <circle key={i} cx={x} cy={y} r={i < shown ? r : r * 0.5} className={i >= from && i < shown ? "leaf-sprout" : ""} style={{ animationDelay: `${(i - from) * 90}ms` }}
          fill={i < shown ? (i % 3 === 0 ? "#17A2A2" : i % 3 === 1 ? "#2BA36B" : "#3E9F6E") : "#C9B48A"} opacity={i < shown ? 0.95 : 0.4} />
      ))}
      {seeds > 0 && LEAVES.slice(0, Math.min(5, seeds)).map(([x, y], i) => <circle key={`s${i}`} cx={x + 6} cy={y + 8} r="3.4" fill="#E0B33A" />)}
    </svg>
  );
};
